import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Từ năm: ", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Đến năm: ", -1)
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Dân số chung", -1)
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Số quận/huyện", -1)
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Số xã/phường", -1)
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số cán bộ làm công tác y tế trường học tuyến tỉnh (Trung tâm YTDP tỉnh/CDC)", -1)
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số cán bộ làm công tác y tế trường học tuyến huyện (Trung tâm y tế huyện)", -1)
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số cán bộ làm công tác y tế trường học tuyến xã (Trạm y tế xã)", -1)
const _hoisted_19 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số nhân viên y tế trong trường học/số trường của tỉnh", -1)
const _hoisted_21 = { class: "p-fluid" }
const _hoisted_22 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_23 = { class: "p-field p-col p-col-12 p-md-12 p-lg-5" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_25 = { class: "p-field p-col p-col-12 p-md-12 p-lg-5" }
const _hoisted_26 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Trong đó số nhân viên y tế trường học có chuyên môn y", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { style: {"font-style":"italic"} }, "(Đối với tỉnh đã chuyển nhân viên y tế trong các trường học từ ngành giáo dục sang ngành y tế quản lý, đề nghị ghi rõ)", -1)
const _hoisted_29 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_30 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_31 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Trong đó Số lượng phòng y tế đủ điều kiện/phòng y tế chưa đảm bảo", -1)
const _hoisted_33 = { class: "p-fluid" }
const _hoisted_34 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_35 = { class: "p-field p-col p-col-12 p-md-12 p-lg-5" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_37 = { class: "p-field p-col p-col-12 p-md-12 p-lg-5" }
const _hoisted_38 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_39 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_40 = { class: "p-fluid" }
const _hoisted_41 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_42 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_43 = { class: "p-fluid" }
const _hoisted_44 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_45 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_46 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_47 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_48 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_49 = { class: "p-fluid" }
const _hoisted_50 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_51 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_52 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_53 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_54 = { class: "p-fluid" }
const _hoisted_55 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_56 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_57 = { class: "p-fluid" }
const _hoisted_58 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_59 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_60 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_61 = { class: "p-fluid" }
const _hoisted_62 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_63 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_64 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "I. Thông tin chung" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_Calendar, {
                    modelValue: $setup.baoCao.tuNam,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.baoCao.tuNam) = $event)),
                    touchUI: "",
                    view: "year",
                    dateFormat: "yy"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_Calendar, {
                    modelValue: $setup.baoCao.denNam,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.baoCao.denNam) = $event)),
                    touchUI: "",
                    view: "year",
                    dateFormat: "yy"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_InputText, {
                    id: "danSoChung",
                    type: "text",
                    modelValue: $setup.baoCao.danSoChung,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.baoCao.danSoChung) = $event)),
                    placeholder: "Nhập dân số chung"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_InputText, {
                    id: "soQuan",
                    type: "text",
                    modelValue: $setup.baoCao.soQuan,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.baoCao.soQuan) = $event)),
                    placeholder: "Nhập số quận/huyện"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_InputText, {
                    id: "soPhuong",
                    type: "text",
                    modelValue: $setup.baoCao.soPhuong,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.baoCao.soPhuong) = $event)),
                    placeholder: "Nhập số xã/phường"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_InputText, {
                    id: "tongSoCanBoTinh",
                    type: "text",
                    modelValue: $setup.baoCao.tongSoCanBoTinh,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.baoCao.tongSoCanBoTinh) = $event)),
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_InputText, {
                    id: "tongSoCanBoHuyen",
                    type: "text",
                    modelValue: $setup.baoCao.tongSoCanBoHuyen,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.baoCao.tongSoCanBoHuyen) = $event)),
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_InputText, {
                    id: "tongSoCanBoXa",
                    type: "text",
                    modelValue: $setup.baoCao.tongSoCanBoXa,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.baoCao.tongSoCanBoXa) = $event)),
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_InputText, {
                          id: "tongSoNhanVienYTe",
                          type: "text",
                          modelValue: $setup.baoCao.tongSoNhanVienYTe,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.baoCao.tongSoNhanVienYTe) = $event)),
                          placeholder: "Tổng số nhân viên y tế "
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_InputText, {
                          id: "tongSoTruong",
                          type: "text",
                          modelValue: $setup.baoCao.tongSoTruong,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.baoCao.tongSoTruong) = $event)),
                          placeholder: "Tổng số trường của tỉnh"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _hoisted_28,
                  _createVNode(_component_Textarea, {
                    modelValue: $setup.baoCao.soNhanVienYTCoChuyenMon,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.baoCao.soNhanVienYTCoChuyenMon) = $event)),
                    rows: "10"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_Panel, { header: "Nguồn kinh phí triển khai cho công tác y tế trường học của tỉnh" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.nguonKinhPhiTrienKhais,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nội dung",
                                    rowspan: 2,
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Kinh phí",
                                    colspan: 2
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Số tiền",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nguồn",
                                    colspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "Stt",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "",
                            style: {"width":"350px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.noiDung), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTien,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTien) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "soNghiNgo",
                            header: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "nguon",
                                type: "text",
                                modelValue: slotProps.data.nguon,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.nguon) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Panel, { header: "Thông tin về quản lý sức khoẻ" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.quanLySucKhoes,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.noiDung), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số trường"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSoTruong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoTruong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số học sinh"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSoHocSinh,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoHocSinh) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có Ban SK"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSoTruongCoBanSK,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoTruongCoBanSK) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có Phòng y tế"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongCoPhongYT,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongCoPhongYT) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có nhân viên YTTH"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongCoNVYTTH,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongCoNVYTTH) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có XDKH YTTH"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongCoXDKHYTTH,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongCoXDKHYTTH) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có lập sổ theo dõi SK"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongCoLapSoTDSK,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongCoLapSoTDSK) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có khám sức khỏe đầu vào"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongCoKSKDauVao,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongCoKSKDauVao) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có khám SKĐK"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongCoKSDK,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongCoKSDK) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có Bếp ăn tập thể"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongCoBepAnTapThe,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongCoBepAnTapThe) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_InputText, {
                          id: "soLuongPhongYTeDuDK",
                          type: "text",
                          modelValue: $setup.baoCao.soLuongPhongYTeDuDK,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.baoCao.soLuongPhongYTeDuDK) = $event)),
                          placeholder: "Số lượng phòng y tế đủ điều kiện"
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_InputText, {
                          id: "soLuongPhongYTeChuaDB",
                          type: "text",
                          modelValue: $setup.baoCao.soLuongPhongYTeChuaDB,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.baoCao.soLuongPhongYTeChuaDB) = $event)),
                          placeholder: "Số lượng phòng y tế chưa đảm bảo"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_Panel, { header: "Đào tạo tập huấn chuyên môn nghiệp vụ về y tế trường học năm 2022- 2023" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.daoTaoTapHuans,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Lớp do tuyến tỉnh thực hiện",
                                    colspan: 3
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Lớp do tuyến huyện thực hiện",
                                    colspan: 3
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Đối tượng",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số lớp",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số học viên",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Đối tượng",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số lớp",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số học viên",
                                    colspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "Stt",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.doiTuongTuyenTinh), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số trường"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soLopTuyenTinh,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLopTuyenTinh) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số học sinh"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soHocVienTuyenTinh,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soHocVienTuyenTinh) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.doiTuongTuyenHuyen), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số trường"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soLopTuyenHuyen,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLopTuyenHuyen) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số học sinh"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soHocVienTuyenHuyen,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soHocVienTuyenHuyen) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_Panel, { header: "Truyền thông giáo dục sức khỏe, tư vấn sức khỏe" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.truyenThongGiaoDucSKs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Nội dung và đối tượng"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "noiDungVaDoiTuong",
                                type: "text",
                                modelValue: slotProps.data.noiDungVaDoiTuong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.noiDungVaDoiTuong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Hình thức"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "hinhThuc",
                                type: "text",
                                modelValue: slotProps.data.hinhThuc,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.hinhThuc) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số lượt"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soLuot,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuot) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số lượng "
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soLuong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "II. Điều kiện về cơ sở vật chất, cấp thoát nước, vệ sinh môi trường" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_DataTable, {
                    value: $setup.baoCao.dieuKienVeCSVatChats,
                    showGridlines: "",
                    rows: 40,
                    rowHover: true,
                    style: {"font-size":"14px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "TT",
                        style: {"width":"20px"}
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        header: "Nội dung"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createElementVNode("label", null, _toDisplayString(slotProps.data.noiDung), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSo",
                        header: "Số trường kiểm tra"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soTruongKT,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongKT) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSo",
                        header: "Số trường Đạt"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soTruongDat,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongDat) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSo",
                        header: "%"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.phanTram,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.phanTram) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "III. Hoạt động quản lý, bảo vệ và chăm sóc sức khỏe học sinh" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_Panel, { header: "1. Tình hình bệnh tật trong năm học vừa qua" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.tinhHinhBenhTatTrongNams,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nguy cơ sức khỏe",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số học sinh",
                                    colspan: 9
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Suy dinh dưỡng",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Thừa cân, béo phì",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Bệnh răng miệng",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Bệnh về mắt",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tim mạch",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Hô hấp",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tâm thần - thần kinh",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Bệnh cơ xương khớp",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Khác",
                                    colspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "TT",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.nguyCoSucKhoe), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường kiểm tra"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.suyDinhDuong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.suyDinhDuong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường Đạt"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.thuaCan,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.thuaCan) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.benhRangMieng,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.benhRangMieng) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.benhVeMat,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.benhVeMat) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.timMach,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.timMach) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.hoHap,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.hoHap) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tamThan,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tamThan) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.benhCoXuongKhop,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.benhCoXuongKhop) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.khac,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.khac) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_Panel, { header: "2. Tình hình dịch, bệnh truyền nhiễm trong năm học vừa qua" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.tinhHinhDichBenhTruyenNhiems,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tên dịch bệnh",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tiêu chảy",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tay chân miệng",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Sởi",
                                    colspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Quai bị",
                                    colspan: 2
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Số vụ",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số ca",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số vụ",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số ca",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số vụ",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số ca",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số vụ",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số ca",
                                    colspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "TT",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.nguyCoSucKhoe), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường kiểm tra"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soVuTieuChay,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soVuTieuChay) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường Đạt"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soCaTieuChay,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCaTieuChay) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soVuTayChan,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soVuTayChan) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soCaTayChan,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCaTayChan) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soVuSoi,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soVuSoi) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soCaSoi,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCaSoi) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soVuQuaiBi,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soVuQuaiBi) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soCaQuaiBi,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCaQuaiBi) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_Panel, { header: "3. Tai nạn thương tích trong năm học vừa qua" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.taiNanThuongTichs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ColumnGroup, { type: "header" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "TT",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Nguy cơ sức khỏe",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số trường có báo cáo",
                                    rowspan: 2
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Số trường hợp mắc",
                                    colspan: 10
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Trượt, ngã",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Bỏng",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Đuối nước",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Điện giật",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Súc vật cắn",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Ngộ độc",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Hóc dị vật",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Cắt vào tay chân",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Bị đánh",
                                    colspan: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    header: "Tai nạn giao thông",
                                    colspan: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "TT",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.nguyCoSucKhoe), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường kiểm tra"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongBaoCao,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongBaoCao) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường Đạt"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.truotNga,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.truotNga) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.bong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.bong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.duoiNuoc,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.duoiNuoc) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.dienGiat,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.dienGiat) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.sucVatCan,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sucVatCan) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.ngoDoc,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.ngoDoc) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.hocDiVat,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.hocDiVat) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.catVaoTayChan,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.catVaoTayChan) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.biDanh,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.biDanh) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.taiNanGiaoThong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiNanGiaoThong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_Panel, { header: "4. Vệ sinh an toàn thực phẩm" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.veSinhAnToanTPs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.noiDung), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có kiểm tra"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "soTruongCoKiemTra",
                                type: "text",
                                modelValue: slotProps.data.soTruongCoKiemTra,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongCoKiemTra) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Đạt"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.dat,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.dat) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "%"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.phanTram,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.phanTram) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "IV. Công tác khác" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_Panel, { header: "1. Tiêm chủng phòng bệnh trong các chiến dịch tại trường" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.tiemChungPhongBenhTaiTruongs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Loại vắc xin"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputText, {
                                id: "ghiChu",
                                type: "text",
                                modelValue: slotProps.data.loaiVacXin,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.loaiVacXin) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số học sinh cần tiêm"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSoHocSinhCanTiem,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoHocSinhCanTiem) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số học sinh được tiêm"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSoHocSinhDuocTiem,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoHocSinhDuocTiem) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tỷ lệ %"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tyLePhanTram,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tyLePhanTram) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_Panel, { header: "2. Triển khai các chương trình y tế và phong trào vệ sinh phòng bệnh tại các trường" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.truongKhaiCacChuongTrinhYTes,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.noiDung), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số trường"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSoTruong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoTruong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có triển khai"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongTrienKhai,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongTrienKhai) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_Panel, { header: "3. Hoạt động truyền thông giáo dục sức khỏe tại các trường" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        value: $setup.baoCao.hoaDongTruyenThongGiaoDucs,
                        showGridlines: "",
                        rows: 40,
                        rowHover: true,
                        style: {"font-size":"14px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            style: {"width":"20px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Nội dung"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("label", null, _toDisplayString(slotProps.data.noiDung), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Tổng số trường"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.tongSoTruong,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoTruong) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "tongSo",
                            header: "Số trường có triển khai"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode(_component_InputNumber, {
                                inputId: "integeronly",
                                modelValue: slotProps.data.soTruongTrienKhai,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.soTruongTrienKhai) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "V. Khó khăn, vướng mắc trong triển khai công tác y tế trường học" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_Textarea, {
                    modelValue: $setup.baoCao.khoKhanVuongMac,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.baoCao.khoKhanVuongMac) = $event)),
                    rows: "10"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "VI. Đề xuất. Kiến nghị của địa phương" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(_component_Textarea, {
                    modelValue: $setup.baoCao.deXuat,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.baoCao.deXuat) = $event)),
                    rows: "10"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_Button, {
                    label: "Gởi báo cáo",
                    icon: "pi pi-upload",
                    severity: "secondary",
                    raised: "",
                    onClick: $setup.addReport
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}